import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import Home from './pages/Home/Home';
import DashboardPage from './pages/UserDashboard/UserDashboardPages/DashboardPage/DashboardPage';
import PersonalProfile from './pages/UserDashboard/UserDashboardPages/EditProfile/PersonalProfile';
import ReligiousProfile from './pages/UserDashboard/UserDashboardPages/EditProfile/ReligiousProfile';
import FamilyProfile from './pages/UserDashboard/UserDashboardPages/EditProfile/FamilyProfile';
import EducationProfile from './pages/UserDashboard/UserDashboardPages/EditProfile/EducationProfile';
import AddressProfile from './pages/UserDashboard/UserDashboardPages/EditProfile/AddressProfile';
import PhotoAlbum from './pages/UserDashboard/UserDashboardPages/PhotoAlbumPages/PhotoAlbum';
import LatestRequest from './pages/UserDashboard/UserDashboardPages/DashboardPage/LatestRequest/LatestRequest';
import AboutMore from './pages/UserDashboard/UserDashboardPages/EditProfile/AboutMore';
import MatchPreferences from './pages/UserDashboard/UserDashboardPages/EditProfile/MatchPreferences';
import FindProfile from './pages/UserDashboard/UserDashboardPages/FindProfilePages/FindProfile';
import ProfileLooksLike from './pages/UserDashboard/UserDashboardPages/ProfileLooksLikePages/ProfileLooksLike';
import HoroscopeEdit from './pages/UserDashboard/UserDashboardPages/EditProfile/HoroscopeEdit';
import PrivateRoute from './components/PrivateRoute';
import AboutUs from './pages/aboutUs/AboutUs';
import TermsAndCondition from './pages/termsAndCondition/TermsAndCondition';
import RefundPolicy from './pages/refundPolicy/RefundPolicy';
import PrivacyPolicy from './pages/privacyPolicy/PrivacyPolicy';
import CancellationPolicy from './pages/cancellationPolicy/CancellationPolicy';
import ViewProfile from './pages/AllMatches/viewProfile/ViewProfile';
import MatchNow from './pages/MatchNow/MatchNow';
import Signin from './pages/Signin/Signin';
import Signup from './pages/Signup/Signup';
import ForgotPassword from './pages/ForgotPassword/ForgotPassword';
import ResetPassword from './pages/ForgotPassword/ResetPassword';
import ContactUs from './pages/ContactUs/ContactUs';
import MobileUserTroubleshootGuide from './pages/MobileUserTroubleshootGuide/MobileUserTroubleshootGuide';
import FindProfileMatches from './pages/UserDashboard/UserDashboardPages/FindProfilePages/FindProfileMatches';
import DeleteMyProfile from './pages/UserDashboard/UserDashboardPages/DeleteMyProfile/DeleteMyProfile';

const AppRoutes = ({
  onShowBasicInfo,
  onShowSignUp,
  onShowPaymentLayout,
  onShowSuccessMessage,
}) => {
  return (
    <Routes>
      {/* Public Routes */}

      <Route
        path='/'
        element={
          <Home onShowBasicInfo={onShowBasicInfo} onShowSignUp={onShowSignUp} />
        }
      />

      <Route
        path='/signup'
        element={<Signup onShowSuccessMessage={onShowSuccessMessage} />}
      />
      <Route
        path='/signin'
        element={<Signin onShowSuccessMessage={onShowSuccessMessage} />}
      />
      <Route
        path='/forgot-password'
        element={<ForgotPassword onShowSuccessMessage={onShowSuccessMessage} />}
      />
      <Route
        path='/reset-password/:token'
        element={<ResetPassword onShowSuccessMessage={onShowSuccessMessage} />}
      />

      <Route
        path='/mobile-trubleshoot-guide'
        element={<MobileUserTroubleshootGuide />}
      />

      <Route path='/about-us' element={<AboutUs />} />
      <Route path='/terms-condition' element={<TermsAndCondition />} />
      <Route path='/refund-policy' element={<RefundPolicy />} />
      <Route path='/privacy-policy' element={<PrivacyPolicy />} />
      <Route path='/privacy-policy' element={<PrivacyPolicy />} />
      <Route path='/cancellation-policy' element={<CancellationPolicy />} />
      <Route path='/contact-us' element={<ContactUs />} />

      {/* Protected Routes */}
      <Route element={<PrivateRoute />}>
        <Route
          path='/dashboard'
          element={
            <DashboardPage
              onShowPaymentLayout={onShowPaymentLayout}
              onShowSuccessMessage={onShowSuccessMessage}
            />
          }
        />
        <Route path='/dashboard/latest-request' element={<LatestRequest />} />
        <Route path='/findprofile' element={<FindProfile />} />
        <Route path='/deleteMyProfile' element={<DeleteMyProfile />} />
        <Route
          path='/findprofile/profile-matches'
          element={<FindProfileMatches />}
        />

        <Route
          path='/edit-profile'
          element={<PersonalProfile onShowEditSuccess={onShowSuccessMessage} />}
        />
        <Route
          path='/edit-profile/personal'
          element={<PersonalProfile onShowEditSuccess={onShowSuccessMessage} />}
        />
        <Route
          path='/edit-profile/religious'
          element={
            <ReligiousProfile onShowEditSuccess={onShowSuccessMessage} />
          }
        />
        <Route
          path='/edit-profile/family'
          element={<FamilyProfile onShowEditSuccess={onShowSuccessMessage} />}
        />
        <Route
          path='/edit-profile/education'
          element={
            <EducationProfile onShowEditSuccess={onShowSuccessMessage} />
          }
        />
        <Route
          path='/edit-profile/address'
          element={<AddressProfile onShowEditSuccess={onShowSuccessMessage} />}
        />

        <Route
          path='/edit-profile/horoscopeedit'
          element={<HoroscopeEdit onShowEditSuccess={onShowSuccessMessage} />}
        />
        <Route
          path='/edit-profile/aboutmore'
          element={<AboutMore onShowEditSuccess={onShowSuccessMessage} />}
        />
        <Route
          path='/edit-profile/matchpreferences'
          element={
            <MatchPreferences onShowEditSuccess={onShowSuccessMessage} />
          }
        />
        <Route path='/photo-album' element={<PhotoAlbum />} />

        <Route path='/profilelookslike' element={<ProfileLooksLike />} />
        <Route path='/view-profile' element={<ViewProfile />} />
        <Route path='/view-profile/match-now' element={<MatchNow />} />
      </Route>

      {/* Catch-all redirect to home for unauthenticated users */}
      <Route path='*' element={<Navigate to='/' />} />
    </Routes>
  );
};

export default AppRoutes;
